export default __webpack_public_path__ + "static/media/12s.cc420426.svg";